import React from "react";

const Disclaimer = ({ onAccept, onReject }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black/70">
      <div
      className="w-full max-w-lg p-8 rounded-2xl text-white border"
      style={{
        background: "rgba(0, 0, 0, 0.78)",
        backdropFilter: "blur(12px)",
        boxShadow: "0 25px 50px rgba(0,0,0,0.7)",
        border: "1px solid rgba(255,255,255,0.15)",
      }}
      >

        <h2 className="text-2xl font-bold mb-4 text-center text-purple-400">
          Disclaimer
        </h2>

        <ul className="list-disc pl-6 space-y-2 text-gray-200 mb-8 text-sm">
          <li>Ensure that all details provided are accurate.</li>
          <li>Video KYC requires a stable internet connection.</li>
          <li>Your data is securely stored and processed.</li>
        </ul>

        <div className="flex gap-4 mt-4">
          <button
            onClick={onReject}
            className="btn-white flex-1"
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL}/White2.png)`,
              height: "48px",
              borderRadius: "6px",
              fontWeight: "600",
            }}
          >
            Reject
          </button>

          <button
            onClick={onAccept}
            className="btn-black flex-1"
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL}/Black2.png)`,
              height: "48px",
              borderRadius: "6px",
              fontWeight: "600",
            }}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
